import { VariableName } from './enums';

export const commandOptions = [
  {
    value: {
      type: 'minimize-window-command',
    },
    label: 'Window - Minimize',
  },
  {
    value: {
      type: 'hide-window-command',
    },
    label: 'Window - Close',
  },
  // {
  //   value: {
  //     type: 'maximize-restore-window-command',
  //   },
  //   label: 'Window - Maximize/Restore',
  // },
  {
    value: {
      type: 'start-app-command',
    },
    label: 'App - Start',
  },
  {
    value: {
      type: 'start-app-install-task-command',
    },
    label: 'App - Install',
  },
  {
    value: {
      type: 'start-app-uninstall-task-command',
    },
    label: 'App - Uninstall',
  },
  {
    value: {
      type: 'start-app-update-task-command',
    },
    label: 'App - Update',
  },
  {
    value: {
      type: 'start-app-repair-task-command',
    },
    label: 'App - Repair',
  },
  // {
  //   value: {
  //     type: 'cancel-app-ongoing-task-command',
  //   },
  //   label: 'Task - Cancel current',
  // },
  // {
  //   value: {
  //     type: 'restart-last-app-task-command',
  //   },
  //   label: 'Task - Restart last',
  // },
  {
    value: {
      type: 'open-external-link-command',
    },
    label: 'Browser - Open link',
  },
];

export const variableOptions = [
  { value: VariableName.AppName, label: 'App Name' },
  {
    value: VariableName.AppDescription,
    label: 'App Description',
  },
  {
    value: VariableName.AppVersionLabel,
    label: 'App Version Label',
  },
  {
    value: VariableName.AppTaskOperationName,
    label: 'Task Operation Name',
  },
  {
    value: VariableName.AppTaskPackageSize,
    label: 'Task Package Size',
  },
  {
    value: VariableName.AppTaskDownloadedSize,
    label: 'Task Downloaded Size',
  },
  {
    value: VariableName.AppTaskDownloadSpeed,
    label: 'Task Download Speed',
  },
  {
    value: VariableName.AppTaskPercentage,
    label: 'Task Percentage',
  },
  {
    value: VariableName.AppInstallPath,
    label: 'App Install Path',
  },
  {
    value: VariableName.AppInstallPackageSize,
    label: 'App Install Package Size',
  },
  {
    value: VariableName.AppUpdatePackageSize,
    label: 'App Update Package Size',
  },
];

export const fontFamilyOptions = [
  { value: undefined, label: '' },
  { value: 'Inter', label: 'Inter' },
  { value: 'Arial', label: 'Arial' },
  { value: 'Helvetica', label: 'Helvetica' },
  { value: 'Times New Roman', label: 'Times New Roman' },
  { value: 'Georgia', label: 'Georgia' },
  { value: 'Verdana', label: 'Verdana' },
  { value: 'Tahoma', label: 'Tahoma' },
  { value: 'Courier New', label: 'Courier New' },
  { value: 'Trebuchet MS', label: 'Trebuchet MS' },
];

export const fontWeightOptions = [
  { value: undefined, label: '' },
  { value: 100, label: '100 - Thin' },
  { value: 200, label: '200 - Light' },
  { value: 300, label: '300 - Book' },
  { value: 400, label: '400 - Regular' },
  { value: 500, label: '500 - Medium' },
  { value: 600, label: '600 - Semi-Bold' },
  { value: 700, label: '700 - Bold' },
  { value: 800, label: '800 - Extra-Bold' },
  { value: 900, label: '900 - Heavy' },
];

export const overflowOptions = [
  { value: undefined, label: '' },
  { value: 'auto', label: 'Auto Scrollbars' },
  { value: 'hidden', label: 'Hidden' },
];

export const textDecorationLineOptions = [
  { value: undefined, label: '' },
  { value: 'none', label: 'None' },
  { value: 'underline', label: 'Underline' },
  { value: 'overline', label: 'Overline' },
  { value: 'line-through', label: 'Line-Through' },
];

export const borderStyleOptions = [
  { value: undefined, label: '' },
  { value: 'none', label: 'None' },
  { value: 'solid', label: 'Solid' },
  { value: 'dashed', label: 'Dashed' },
  { value: 'dotted', label: 'Dotted' },
];
